export default __webpack_public_path__ + "static/media/menu-hamburger.63789cb2.svg";